import axios from "../../axios-config";

// Raw events reported to the backend. The backend derives the actual reward
// milestone activityTypes (launch_first_campaign, launch_third_campaign, etc.)
// from these based on cumulative counts — mirrors the ProfessorU content-activity
// pattern (one raw event -> multiple threshold milestones).
export const GROWTH_ENGINE_ACTIVITY_TYPES = {
  LAUNCH_CAMPAIGN: "launch_campaign",
  VISIT_CAMPAIGN_HISTORY: "visit_campaign_history",
  EDIT_CAMPAIGN: "edit_campaign",
  // Raw event: user visited the Campaign Editor (analytics view) for a specific
  // campaign. The backend derives the "review_analytics" reward milestone from
  // this only when metadata.isFirstLaunchedCampaign && metadata.hasEnded are true.
  VISIT_CAMPAIGN_EDITOR: "visit_campaign_editor",
};

/**
 * Track a single Growth Engine activity event.
 * The backend aggregates these events into reward progress and returns
 * any newly reached milestones (completed rewards) in `milestonesReached`.
 *
 * @param {string} activityType - one of GROWTH_ENGINE_ACTIVITY_TYPES
 * @param {object} metadata - context such as campaignId
 */
export const trackGrowthEngineActivity = async (activityType, metadata = {}) => {
  const response = await axios.post("/user/v1/activity/track", {
    activityType,
    metadata,
  });
  return response?.data?.data || { isFirstVisit: false, visitCount: 0, milestonesReached: [] };
};
